export default {"src":"/_next/static/media/tap-image-zoom.870cb4c5.svg","height":58,"width":224,"blurWidth":0,"blurHeight":0};